export default __webpack_public_path__ + "static/bidra-i-figma8-b0a4b7eeba071e3f4e5333aa5a59d432.png";